import { Grid } from "basis";
import { capitaliseEveryWord } from "library/utils";
import { useHardshipApplicationContext } from "../../hooks/useHardshipApplicationContext";
import { getAuthorisedPersonDetails } from "../../reducer/hardshipSelectors";
import { TextCell } from "../TextCell";

export const AuthorisedPersonDetails = () => {
  const { state } = useHardshipApplicationContext();
  const { fullName, counsellorName, email, contactNumber } =
    getAuthorisedPersonDetails(state.personalDetails);

  return (
    <Grid
      cols="8"
      colsGap-sm="4"
      rowsGap="8"
      testId="authorised-section"
      margin="4 0 0 0"
    >
      <Grid.Item colSpan="all" colSpan-sm="0-3" rowSpan-sm="0">
        <TextCell header="Your name" testId="authorised-name">
          {capitaliseEveryWord(fullName)}
        </TextCell>
      </Grid.Item>
      <Grid.Item colSpan="all" colSpan-sm="4-8" rowSpan-sm="0">
        <TextCell
          header="Organisation or Financial Counsellor’s name"
          testId="organisation-name"
        >
          {capitaliseEveryWord(counsellorName)}
        </TextCell>
      </Grid.Item>
      <Grid.Item colSpan="all" colSpan-sm="0-3" rowSpan-sm="1">
        <TextCell header="Email address" testId="authorised-email">
          {email}
        </TextCell>
      </Grid.Item>
      <Grid.Item colSpan="all" colSpan-sm="4-8" rowSpan-sm="1">
        <TextCell header="Contact number" testId="authorised-contact-number">
          {contactNumber}
        </TextCell>
      </Grid.Item>
    </Grid>
  );
};
